/* eslint-disable no-console */
<template>

    <div class="main_unit">
        <pulse-loader class="w-100 text-center" :loading="isInitLoading"></pulse-loader>
        <div v-show="!isInitLoading">
            <div class="store_login_unit_manage_menu">企業管理者画面</div>
            <div class="store_tbl_unit wd976 tbl_ht_login_info tbl_bg_blue">
                <form class="form_checkSetting">

                  <div class="wd400">
                      <p v-if="bottunid== 3" class="checkSetting_text">TOPメニュー画面 {{this.buttonname}}</p>
                  </div><br>

                  <div class="wd720">
                      <Message v-if="ApivalidationMessage" :validationMessage="ApivalidationMessage" />
                    <label id="health_check_item_err" class="lavel_error_font ">{{validationResult}}</label>
                  </div>


                  <div v-if="bottunid== 3" class="lavel_store right_comment">
                    <label>チェック項目設定</label>
                  </div>
                  <div  v-if="bottunid== 3" style="padding: 15px" id="pageSetting" name="pageSetting" >
                    <table class="checkSetting_tbl_unit">
                      <tbody>
                      <tr>
                        <th class="wd100 checkSetting_text_align">表示順</th>
                        <th class="wd400 checkSetting_text_align">チェック内容</th>
                        <th class="wd180 checkSetting_text_align" >表示設定</th>
                        <th class="wd100 checkSetting_text_align" >移動</th>
                      </tr>
                      <tr v-for="(healthCheckItem, index) in healthCheckItemList" :key=healthCheckItem.dailyCheckItemNo>
                        <td class="wd100 checkSetting_text_align">{{index+1}}</td>
                        <td class="wd400 view_setting_text_td">
                          <input type="text" class="view_setting_text_input w-100 h-100" v-model="healthCheckItem.healthCheckItemName" maxlength="30">
                        </td>
                        <td class="wd180 checkSetting_text_align">
                          <a href="#" role="button" v-if="healthCheckItem.displayFlg == true"
                             v-on:click.prevent.stop="clickChech($event,index)" :id="'hd_' +healthCheckItem.healthCheckItemId">
                            <p class="icn_blue_td"><i class="far fa-circle"></i></p></a>
                          <a href="#" role="button" v-else-if="healthCheckItem.displayFlg == false" v-on:click.prevent.stop="clickChech($event,index)">
                            <p class="icn_red_td"><i class="fas fa-times"></i></p></a>
                          <a href="#" role="button" v-else v-on:click.prevent.stop="clickChech($event,index)">
                            <p class="icn_white_td"><i class="far fa-circle"></i></p></a>
                        </td>
                        <td v-if="healthCheckItem.displayNo == 1" class="wd100" style="text-align: center" >
                          <input type="button" value="▼" @click="lowdailyCheckItemNo(healthCheckItem.displayNo)">
                        </td>
                        <td v-else-if="healthCheckItem.displayNo == 50" class="wd100" style="text-align: center" >
                          <input type="button" value="▲" @click="updailyCheckItemNo(healthCheckItem.displayNo)"><br>
                        </td>
                        <td v-else class="wd100" style="text-align: center">
                          <input type="button" value="▲" @click="updailyCheckItemNo(healthCheckItem.displayNo)"><br>
                          <input type="button" value="▼" @click="lowdailyCheckItemNo(healthCheckItem.displayNo)">
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </form><br>
            </div>
            <div>
                <div class="btn_submit" style="text-align: center">
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li>
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="cancel">キャンセル</a></li>
                    </ul>
                    <ul class="set_ul_tbl_buttan" style="display: inline-block">
                        <li><a class="checkSetting_buttan_unit " href="#" @click.prevent.stop="openModel">更新</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="overlay" v-show="showContent">
          <div>
            <div class="modal_box wd512">
              <div class="modal_header_unit">
                <div class="modal_header_box">
                  <p class="modal_header_tit_s">チェック内容設定編集</p>
                  <p v-if="bottunid== 3" class="checkSetting_text">TOPメニュー画面 {{this.buttonname}}</p>
                </div>
              </div>
              <div class="modal_content_tex">
                <p>チェック内容設定編集の更新が<br>
                  が完了しました。</p>
              </div>

              <div class="btn_submit_box">
                <div class="btn_submit">
                  <a href="#" @click.prevent.stop="closeModel">OK</a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="overlay" v-show="showContent2">
            <div>
                <div class="modal_box wd512">
                    <div class="modal_header_unit">
                        <div class="modal_header_box">
                            <p class="modal_header_tit_s">チェック内容設定編集</p>
                            <p v-if="bottunid== 3" class="checkSetting_text">TOPメニュー画面 {{this.buttonname}}</p>
                        </div>
                    </div>
                    <div class="modal_content_tex">
                        <p>この編集は取り消すことができません。<br>
                            変更して宜しいですか？</p>
                    </div>

                    <div class="btn_submit_box">
                      <div class="btn_submit">
                        <a href="#" @click.prevent.stop="closeModel2">キャンセル</a>
                      </div>
                        <div class="btn_submit">
                            <a href="#" @click.prevent.stop="sendDate">OK</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overlay_loder" v-show="isLoading">
            <pulse-loader class="w-100 text-center" :loading="isLoading"></pulse-loader>
        </div>
    </div>

</template>

<script>

    import PulseLoader from '@/app/components/PulseLoader.vue'
    import Message from '@/app/components/Message.vue'

export default {
    name: 'CheckViewSetting',
    components: {
        PulseLoader,
        Message
    },
    data: function () {
        return {
            isLoading:false,
            isInitLoading:true,
            ApivalidationMessage:'',
            validationResult:"",
            brandId: '',
            addFormFlg: true,
            showContent:false,
            showContent2:false,
            healthCheckItem:[],
            healthCheckItemList:[
              {
                healthCheckItemId: null,
                healthCheckItemNo: null,
                healthCheckItemName: '',
                displayFlg:null,
                displayNo:0,
              }
            ],
        }
    },
    computed: {
        brandPath: function () {
            return this.$store.getters['brand/path']
        },
        id: function () {
            return this.$store.getters['checkPage/id']
        },
        bottunid: function () {
            return this.$store.getters['checkPage/buttonId']
        },
        buttonname: function () {
            return this.$store.getters['checkPage/buttonName']
        },
    },
    created: async function(){
        await this.calc();
    },
    methods:{
        async calc(){

            var apiResponseFlg = true;

            // 企業ブランドIDの取得
            this.brandId = this.$store.getters['brand/id']
            // 当日日付取得
            var currentTime = this.getCurrentTime();
            // メニューページ設定概要取得API
            await this.$axios
                .get(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/healthCheck/' + this.id, { params: { datetime: currentTime } })
                .then(response => (this.healthCheckItem = response.data.healthCheckItem))
                .catch((err) => {
                  let error = {
                    button: {
                      path: {name: 'top', params:{brandPath: this.brandPath}}
                    }}
                  apiResponseFlg = false;
                  if (err.customError) {
                    error = Object.assign(error, err.customError)
                  }
                  this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }).finally(()=> this.isInitLoading = false);
            if(apiResponseFlg){
              this.healthCheckItemData();
            }
        },
        openModel() {
          this.showContent2 = true;
        },
        async sendDate() {
          this.showContent2 = false;
          this.isLoading = true;
          this.ApivalidationMessage = '';
          var apiResponseFlg = true;

          // バリデーションチェック
          this.validationCheck();
          if(!this.addFormFlg){
            this.isLoading = false;
            this.scrollTop();
            return null;
          }

          // request作成
          var requestBodyTop = {
            health_check_item: [],
          }
          var healthCheckItems = [];
          this.healthCheckItemList.forEach(healthCheckItem => {

            if(healthCheckItem.displayFlg !== null){
              var inputHealthCheckItem = {
                fk_brand_id: this.brandId,
                health_check_item_no: healthCheckItem.healthCheckItemNo,
                health_check_item_name: healthCheckItem.healthCheckItemName,
                display_flg: healthCheckItem.displayFlg,
                display_no: healthCheckItem.displayNo,
              }
              healthCheckItems.push(inputHealthCheckItem);
            }
          });
          requestBodyTop.health_check_item = healthCheckItems;


          var formRequestBodyTop = this.jsonToFormData(requestBodyTop);

          var configTop = {
            headers: {
              'Content-Type': 'multipart/form-data;'
            }
          }
          //メニューボタン設定更新API
          await this.$axios
              .post(this.$apiEndpoint + 'manage/brand/' + this.brandId + '/healthCheck/' + this.id + '/update',  formRequestBodyTop, configTop)
              .then(response => (this.healthCheckItem = response.data.healthCheckItem))
              .catch((err) => {
                let error = {
                  button: {
                    path: {name: 'top', params:{brandPath: this.brandPath}}
                  }}
                apiResponseFlg = false;
                if (err.customError) {
                  error = Object.assign(error, err.customError);

                  if(error.code == 400){
                    this.ApivalidationMessage =  error.message;
                    this.scrollTop();
                  }
                }
                if(error.code !== 400){
                  this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
                }
              }).finally(()=> this.isLoading = false);

          if(apiResponseFlg){
            this.showContent = true;
          }
        },
        closeModel() {
            this.showContent = false;
        },
        closeModel2() {
          this.showContent2 = false;
        },
        cancel(){
            this.$router.push({name: 'manageCheckViewSetting'});
        },
        clickChech:function (event,index) {
          //ボタン押下時のクリック制御
          var buttonCheckList = this.healthCheckItemList[index];
          switch (buttonCheckList.displayFlg) {
            case 1:
              buttonCheckList.displayFlg = 0;
              break;
            case 0:
              buttonCheckList.displayFlg = 1;
              break;
            case null:
              buttonCheckList.displayFlg = 1;
              break;
          }
          this.healthCheckItemList.splice(index,1,buttonCheckList);
        },
        healthCheckItemData:function(){
          // デイリーデータの表示データを成形
          let itemList = [];
          this.healthCheckItemList = [];
          for(var k = 0 ; k < 50 ; k++){
            var indexList = new Object();
            indexList['healthCheckItemId'] = null;
            indexList['healthCheckItemNo'] = null;
            indexList['healthCheckItemName'] = "";
            indexList['displayFlg'] = null;
            indexList['displayNo'] = k+1;
            if(k < this.healthCheckItem.length) {
              indexList['healthCheckItemId'] = this.healthCheckItem[k]['healthCheckItemId'];
              indexList['healthCheckItemNo'] = this.healthCheckItem[k]['healthCheckItemNo'];
              indexList['healthCheckItemName'] = this.healthCheckItem[k]['healthCheckItemName'];
              indexList['displayFlg'] = this.healthCheckItem[k]['displayFlg'];
              if(this.healthCheckItem[k]['displayNo'] != null) {
                indexList['displayNo'] = this.healthCheckItem[k]['displayNo'];
              }
            }
            itemList.push(indexList);
          }
          this.healthCheckItemList = itemList;
        },
        getCurrentTime() {
            // 当日日付をyyyymmddhhmmssで返却
            var now = new Date();
            var res = now.getFullYear() +
                      this.padZero(now.getMonth() + 1) +
                      this.padZero(now.getDate()) +
                      this.padZero(now.getHours()) +
                      this.padZero(now.getMinutes()) +
                      this.padZero(now.getSeconds());
            return res;
        },
        padZero(num) {
            //先頭ゼロ付加
            var result;
            if (num < 10) {
                result = "0" + num;
            } else {
                result = "" + num;
            }
            return result;
        },
        buildFormData(formData, data, parentKey) {
            if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
                Object.keys(data).forEach(key => {
                    this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
                });
            } else {
                const value = data == null ? '' : data;

                formData.append(parentKey, value);
            }
        },
        jsonToFormData(data) {
            const formData = new FormData();

            this.buildFormData(formData, data);

            return formData;
        },
        validationCheck(){

            this.addFormFlg = true;

            //エラー内容初期化
            this.clearError();

            // 必須チェック
            var disableCount = 0;
            for (var l = 0; l < this.healthCheckItemList.length; l++) {
              if(this.healthCheckItemList[l].displayFlg == 1 && String(this.healthCheckItemList[l].healthCheckItemName).length <= 0 && this.validationResult ==""){
                this.validationResult="チェック項目名("+(l+1)+"列)を入力してください。"
                this.addFormFlg = false;
                break;
              }
              if(this.healthCheckItemList[l].displayFlg == null && String(this.healthCheckItemList[l].healthCheckItemName).length > 0 && this.validationResult ==""){
                this.validationResult="チェック項目("+(l+1)+"列)の表示設定を入力してください。"
                this.addFormFlg = false;
                break;
              }
              if(l > 0 && (this.healthCheckItemList[l].displayFlg != null && String(this.healthCheckItemList[l].healthCheckItemName).length > 0) && this.validationResult ==""){
                if(String(this.healthCheckItemList[l-1].healthCheckItemName).length <= 0) {
                  this.validationResult="チェック項目名("+(l)+"列)を入力してください。"
                  this.addFormFlg = false;
                  break;
                }
              }
              if((this.healthCheckItemList[l].displayFlg != null && String(this.healthCheckItemList[l].healthCheckItemName).length > 0) && this.validationResult ==""){
                if(String(this.healthCheckItemList[l].healthCheckItemName).length > 30) {
                  this.validationResult="チェック項目名("+(l+1)+"列)を30文字以下で指定してください。"
                  this.addFormFlg = false;
                  break;
                }
              }
              if(this.healthCheckItemList[l].displayFlg != 1) {
                disableCount += 1;
              }
            }
            if(this.healthCheckItemList.length == disableCount) {
              this.validationResult="全ての項目を非表示にすることは出来ません。"
              this.addFormFlg = false;
            }
            const itemList = this.healthCheckItemList.filter(item => String(item.healthCheckItemName).length > 0 && item.healthCheckItemName != null)
            const nameList = itemList.map(item => item.healthCheckItemName);
            if(new Set(nameList).size !== nameList.length) {
              this.validationResult="チェック項目名が重複しています。"
              this.addFormFlg = false;
            }
        },
        clearError(){
            //メッセージ初期化
            this.validationResult = "";
        },
        scrollTop() {
            window.scrollTo(0,0);
        },
        updailyCheckItemNo:function (displayNo) {
          var upList = [];
          var lowList = [];
          upList["healthCheckItemId"] = this.healthCheckItemList[displayNo-1].healthCheckItemId;
          upList["healthCheckItemNo"] = this.healthCheckItemList[displayNo-1].healthCheckItemNo;
          upList["healthCheckItemName"] = this.healthCheckItemList[displayNo-1].healthCheckItemName;
          upList["displayFlg"] = this.healthCheckItemList[displayNo-1].displayFlg;
          upList["displayNo"] = this.healthCheckItemList[displayNo-2].displayNo;
          lowList["healthCheckItemId"] = this.healthCheckItemList[displayNo-2].healthCheckItemId;
          lowList["healthCheckItemNo"] = this.healthCheckItemList[displayNo-2].healthCheckItemNo;
          lowList["healthCheckItemName"] = this.healthCheckItemList[displayNo-2].healthCheckItemName;
          lowList["displayFlg"] = this.healthCheckItemList[displayNo-2].displayFlg;
          lowList["displayNo"] = this.healthCheckItemList[displayNo-1].displayNo;
          //配列に反映
          this.healthCheckItemList.splice(displayNo-2,1,upList);
          this.healthCheckItemList.splice(displayNo-1,1,lowList);

        },
        lowdailyCheckItemNo:function (displayNo) {
          var upList = [];
          var lowList = [];
          upList["healthCheckItemId"] = this.healthCheckItemList[displayNo].healthCheckItemId;
          upList["healthCheckItemNo"] = this.healthCheckItemList[displayNo].healthCheckItemNo;
          upList["healthCheckItemName"] = this.healthCheckItemList[displayNo].healthCheckItemName;
          upList["displayFlg"] = this.healthCheckItemList[displayNo].displayFlg;
          upList["displayNo"] = this.healthCheckItemList[displayNo-1].displayNo;
          lowList["healthCheckItemId"] = this.healthCheckItemList[displayNo-1].healthCheckItemId;
          lowList["healthCheckItemNo"] = this.healthCheckItemList[displayNo-1].healthCheckItemNo;
          lowList["healthCheckItemName"] = this.healthCheckItemList[displayNo-1].healthCheckItemName;
          lowList["displayFlg"] = this.healthCheckItemList[displayNo-1].displayFlg;
          lowList["displayNo"] = this.healthCheckItemList[displayNo].displayNo;
          //配列に反映
          this.healthCheckItemList.splice(displayNo-1,1,upList);
          this.healthCheckItemList.splice(displayNo,1,lowList);
        },
    }
}
</script>